import { useEffect } from "react";

/**
 * Extra CSS for a theme's design style (settings.designStyle). Each file is
 * its own download, loaded only for stores using that style, and is written
 * under [data-design="<name>"] so it never touches other themes.
 *
 * Add a style: write its CSS scoped to [data-design="<name>"], then add it here.
 */
const DESIGN_STYLES = {
  prestige: () => import("../assets/frontend/styles/prestige.css"),
};

const loading = {};

export function loadDesignStyle(name) {
  if (!name || !DESIGN_STYLES[name] || loading[name]) return;
  loading[name] = DESIGN_STYLES[name]().catch(() => {
    delete loading[name];
  });
}

export function useDesignStyle(name) {
  useEffect(() => {
    loadDesignStyle(name);
  }, [name]);
}
